/* =============================================================================
   HOW BIDDING WORKS IN THIS SALE — the shared renderer (2026-10-13)
   =============================================================================
   window.MHVBiddingFacts.tooltip(facts)   → the Absentee Bidding badge's tooltip on the
                                             hub, and the Absentee row of the Auction Info
                                             modal: three labelled lines, How / When /
                                             Competitive-or-Blind.
   window.MHVBiddingFacts.styleNote(facts) → registration step 1: what the bidding style
                                             means, in a NEUTRAL box (owner: "not yellow").
   window.MHVBiddingFacts.notice(facts)    → the loud "no live online bidding" line, or ''.
   An ONLINE TIMED CLOSE sale carries `facts.timed` (2026-10-25): styleNote prints its
   one canonical paragraph instead, and the tooltip's rows are How / When / Timed.

   ⚠️ IT RENDERS, IT DOES NOT DECIDE. `facts` is lib/bidding-facts.js's object, served
   by /api/schedule/live-status (event.bidding_facts) and by the registration context
   (event.biddingFacts). Every word comes from there, beside the rule that enforces it,
   so the hub, its modal and the registration modal cannot tell a bidder two different
   things. (The three-column "Absentee Bidding" box this file drew for one afternoon was
   retired the same day for the badge + tooltip.)
   Loaded site-wide (layout/theme.liquid) because the hub and the global registration
   modal both draw from it.
   ============================================================================= */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function tooltip(f) {
    if (!f || !f.summary || !f.summary.length) return '';
    return '<span class="mhv-bf-tip">' + f.summary.map(function (r) {
      return '<span class="mhv-bf-tip-row"><span class="mhv-bf-tip-label">' + esc(r.label) + '</span>' +
        '<span class="mhv-bf-tip-text">' + esc(r.text) + '</span></span>';
    }).join('') + '</span>';
  }

  function styleNote(f) {
    /* An Online Timed Close sale is described by ONE paragraph from the server
       (lib/bidding-facts timed.describe) — and never as "absentee" bidding. */
    /* ⚠️ BROKEN INTO LABELLED SECTIONS (owner, 2026-10-26: "a bigggg text block — lets
       break it up"): `timed.sections` is the same sentences under short headings. A
       server that predates it still sends `describe`, which prints as before. */
    if (f && f.timed && f.timed.sections && f.timed.sections.length) {
      return '<div class="mhv-bf-note mhv-bf-note--timed" role="note"><span class="mhv-bf-note-icon" aria-hidden="true">i</span>' +
        '<div class="mhv-bf-timed"><strong class="mhv-bf-timed-head">How this timed auction works</strong>' +
        f.timed.sections.map(function (s) {
          return '<div class="mhv-bf-timed-row"><span class="mhv-bf-timed-label">' + esc(s.label) + '</span>' +
            '<span class="mhv-bf-timed-text">' + esc(s.text) + '</span></div>';
        }).join('') + '</div></div>';
    }
    if (f && f.timed && f.timed.describe) {
      return '<div class="mhv-bf-note" role="note"><span class="mhv-bf-note-icon" aria-hidden="true">i</span>' +
        '<span><strong>How this timed auction works.</strong> ' + esc(f.timed.describe) + '</span></div>';
    }
    if (!f || !f.absentee || !f.style) return '';
    return '<div class="mhv-bf-note" role="note"><span class="mhv-bf-note-icon" aria-hidden="true">i</span>' +
      '<span><strong>This sale uses ' + esc(String(f.style.label).toLowerCase()) + ' absentee bidding.</strong> ' + esc(f.style.explain) + '</span></div>';
  }

  function notice(f) {
    if (!f || !f.noLiveOnline) return '';
    return '<div class="mhv-bf-notice" role="note"><span class="mhv-bf-notice-icon" aria-hidden="true">!</span>' +
      '<span>' + esc(f.noLiveOnline) + '</span></div>';
  }

  window.MHVBiddingFacts = { tooltip: tooltip, styleNote: styleNote, notice: notice };
})();
